import { RED, YELLOW, GREEN, BLUE } from '../config/colors'
import { red, yellow, green, lightGreen, blue, lime, brown } from '@material-ui/core/colors'
import { colors } from '../charts/theme'
import { landCoverMetadata } from '../config/landCover'
import { wetlandMetadata } from '../config/wetland'
import { cropInventoryMetadata } from '../config/cropInventory.js'

// export const RIVER_CLASS_COLORS = [blue[300], yellow[300], red[300]]
export const RIVER_CLASS_COLORS = ['#044A8F', '#6BC0E9', '#FAF703', '#DC440C']

const RIVER_ICE_DEPTH_COLORS = [blue[50], blue[300], blue[900]]
export const NDVI_COLORS = [
  { 'value': 32, color: '#e37d10', label: '<0' },
  { 'value': 64, color: '#eca119' },
  { 'value': 96, color: '#f5c423', label: '.1' },
  { 'value': 128, color: '#f9dc1f' },
  { 'value': 160, color: '#faf117' },
  { 'value': 192, color: '#e0f911', label: '.2' },
  { 'value': 256, color: '#8efc0b' },
  { 'value': 320, color: '#59e607', label: '.3' },
  { 'value': 352, color: '#47d405', label: '.4' },
  { 'value': 417, color: '#23b002' },
  { 'value': 448, color: '#119e01', label: '.5' },
  { 'value': 1000, color: '#008c00', label: '1' }
]

export const PIPELINE_CHANGE_DETECTION_COLORS = [
  { 'difference': -100, color: blue[500], label: '-100' },
  { 'difference': 0, color: green[500], label: '0' },
  { 'difference': 100, color: yellow[500], label: '100' },
  { 'difference': 200, color: red[500], label: '200' }
]

export const ENERGIR_CHANGE_COLORS = [
  { 'difference': 0, color: blue[500], label: '0' },
  { 'difference': 3, color: green[500], label: '3' },
  { 'difference': 7, color: yellow[500], label: '7' },
  { 'difference': 10, color: red[500], label: '10' }
]

export const PIPELINE_CHANGE_DETECTION_COLORS_DEMO = [
  { 'difference': 0, color: yellow[500], label: '-100' },
  { 'difference': 90, color: red[500], label: '90' }
]

export const Energir = {
  'raster-opacity': 1
}

export const BathymetricWavelet = {
  'raster-opacity': 1
}

export const WellsiteEviControlSimple = {
  'raster-opacity': 1
}

export const RiverIce = {
  'raster-opacity': 1
}



export const SmartIce = {
  'raster-opacity': 1
}

export const SmartIceFeatures = {
  'circle-opacity': 0,
  'circle-radius': 10,
  'circle-stroke-width': 2,
  'circle-stroke-color': 'blue',
  'circle-stroke-opacity': 1


}

export const LandDeformation = {
  'fill-opacity': 1
}

export const PipelineMask = {
  'line-color': 'white',
  'line-offset': -2,
  'line-width': 2
}

// export const LandCover2010 = {
//   'fill-opacity': 1,
//   'fill-color': [
//     'interpolate',
//     ['linear'],
//     ['to-number', ['get', 'LC_class']],
//     ...[].concat(...landCoverMetadata.map(item => [item.value, item.color]))
//   ],
//   'fill-outline-color': 'rgba(0, 0, 0, 0)'
// }

export const Wetlands = {
  'fill-opacity': 1,
  'fill-color': [
    'interpolate',
    ['linear'],
    ['to-number', ['get', 'gridcode']],
    ...[].concat(...wetlandMetadata.map(item => [item.value, item.color]))
  ],
  'fill-outline-color': 'rgba(0, 0, 0, 0)'
}

export const LandCover2010 = {
  'fill-opacity': 1,
  'fill-color': [
    'interpolate',
    ['linear'],
    ['to-number', ['get', 'GRIDCODE']],
    ...[].concat(...landCoverMetadata.map(item => [item.value, item.color]))
  ],
  'fill-outline-color': 'rgba(0, 0, 0, 0)'
}

export const AnnualCropInventory = {
  'fill-opacity': 1,
  'fill-color': [
    'interpolate',
    ['linear'],
    ['to-number', ['get', 'GRIDCODE']],
    ...[].concat(...cropInventoryMetadata.map(item => [item.value, item.color]))
  ],
  'fill-outline-color': 'rgba(0, 0, 0, 0)'
}

export const LandDeformationInsar = {
  'raster-opacity': 1
}

export const Buoys = {
  'circle-opacity': 1,
  'circle-color': 'gray',
  'circle-radius': 5
}

export const RiverIceMarkers = {
  'line-color': lime[900],
  'line-width': 2,
  'line-opacity': 1
}

export const ChurchillMarkers = {
  'line-color': lime[900],
  'line-width': 2,
  'line-opacity': 1
}

export const BriggsIceDepth = {
  'circle-opacity': 1,
  'circle-radius': 5,
  'circle-color': {
    property: 'thick_m',
    type: 'exponential',
    stops: [
      [0, RIVER_ICE_DEPTH_COLORS[0]],
      [0.15, RIVER_ICE_DEPTH_COLORS[1]],
      [0.25, RIVER_ICE_DEPTH_COLORS[2]]
    ]
  },
}

export const PolarviewApp = {
  'circle-opacity': 1,
  'circle-radius': 10,
  'circle-color': 'red'
}

export const BriggsIceType = {
  'fill-opacity': 1,
  'fill-color': [
    'match',
    ['get', 'GRIDCODE'],
    31,
    RIVER_CLASS_COLORS[0],
    32,
    RIVER_CLASS_COLORS[1],
    33,
    RIVER_CLASS_COLORS[2],
    /* other */ 'black'
  ]
}

export const FLOOD_HAZARD_COLORS = [
  '#e9bfff',
  '#d8a7f2',
  '#c78ee6',
  '#b777d9',
  '#a762cc',
  '#984ebf',
  '#8a3eb3',
  '#7c2ea6',
  '#6f2099'
]

export const RIVER_FLOOD_MONITORING_COLORS = [
  // '#ffffff',
  '#ffff00',
  '#bee8ff',
  '#73b2ff',
  '#005be7',
  // '#ffff00',
  '#0D98BA',
  '#a9a800',
  '#ff73de',
  '#aa00e5',
  '#fe0000'
]

export const LEAK_DETECTION_COLORS = [
  '#ea2640',
  '#7058ff',
  '#3ac1ff',
  '#4cf72d',
  '#faf23f',
  '#ff8d1a'
]

export const RiverFloodMonitoring = {
  'fill-opacity': 1,
  'fill-outline-color': 'rgba(0, 0, 0, 0)',
  'fill-color': [
    'interpolate',
    ['linear'],
    ['number', ['get', 'gridcode']],
    1,
    RIVER_FLOOD_MONITORING_COLORS[0],
    2,
    RIVER_FLOOD_MONITORING_COLORS[1],
    3,
    RIVER_FLOOD_MONITORING_COLORS[2],
    4,
    RIVER_FLOOD_MONITORING_COLORS[3],
    5,
    RIVER_FLOOD_MONITORING_COLORS[4],
    6,
    RIVER_FLOOD_MONITORING_COLORS[5],
    7,
    RIVER_FLOOD_MONITORING_COLORS[6],
    8,
    RIVER_FLOOD_MONITORING_COLORS[7],
    9,
    RIVER_FLOOD_MONITORING_COLORS[8],
    10,
    RIVER_FLOOD_MONITORING_COLORS[8]
  ]
}

export const FloodHazard = RiverFloodMonitoring

// export const FloodHazard = {
//   'fill-opacity': 1,
//   'fill-outline-color': 'rgba(0, 0, 0, 0)',
//   'fill-color': [
//     'interpolate',
//     ['linear'],
//     ['number', ['get', 'gridcode']],
//     0,
//     FLOOD_HAZARD_COLORS[0],
//     2,
//     FLOOD_HAZARD_COLORS[1],
//     4,
//     FLOOD_HAZARD_COLORS[2],
//     6,
//     FLOOD_HAZARD_COLORS[3],
//     8,
//     FLOOD_HAZARD_COLORS[4],
//     10,
//     FLOOD_HAZARD_COLORS[5],
//     12,
//     FLOOD_HAZARD_COLORS[6],
//     14,
//     FLOOD_HAZARD_COLORS[7],
//     16,
//     FLOOD_HAZARD_COLORS[8]
//   ]
// }

export const FLOOD_RIVER_COLORS = [
  '#0092de',
  '#ffff00',
  '#ff0000'
]

export const FloodRiverClassification = {
  'fill-opacity': 1,
  'fill-outline-color': 'rgba(0, 0, 0, 0)',
  'fill-color': [
    'match',
    ['get', 'gridcode'],
    31,
    FLOOD_RIVER_COLORS[0],
    32,
    FLOOD_RIVER_COLORS[1],
    33,
    FLOOD_RIVER_COLORS[2],
    /* other */ 'black'
  ]
}

export const BadgerMask = {
  'fill-opacity': 1,
  // 'fill-outline-color': 'rgba(0, 0, 0, 0)',
  // 'fill-color': blue[300]
  'fill-outline-color': blue[300],
  'fill-color': 'rgba(0, 0, 0, 0)'
}

export const ExploitsMarkers = {
  'line-color': lime[900],
  'line-width': 2,
  'line-opacity': 1
}

export const SmartIceQamutik = {
  'raster-opacity': 1
}

export const SmartIceQamutikLineString = {
  'raster-opacity': 1
}

export const Mopra = {
  'raster-opacity': 1
}

export const MopraVector = {
  'fill-opacity': 1,
  'fill-color': {
    property: 'ndvi',
    type: 'exponential',
    stops: [
      [1700, 'brown'],
      [2500, 'bisque'],
      [3300, 'greenYellow'],
      [3700, 'green']
    ]
  },
  'fill-outline-color': {
    property: 'area',
    stops: [[0, 'rgba(0, 0, 0, 0)'], [1, 'gray'], [2, 'white']]
  }
}

export const MopraWellsites = {
  'fill-opacity': 1,
  'fill-color': {
    property: 'ratio',
    stops: [[0.95, RED], [1.0, YELLOW], [1.05, GREEN]]
  }
}

export const WellsiteNdviLease = {
  'raster-opacity': 1
}

export const WellsiteNdviControl = {
  'raster-opacity': 1
}

export const SmartIceQamutikVector = {
  'line-opacity': 1,
  'line-width': 4,
  'line-color': {
    property: 'value',
    type: 'exponential',
    stops: [[0, 'darkOrange'], [10, 'orange'], [20, 'blue'], [58, 'darkBlue']]
  }
}

export const Sentinel1 = {
  'raster-opacity': 1
}

export const Sentinel2Raster = {
  'raster-opacity': 1
}

export const Sentinel2 = {
  'raster-opacity': 1
}

export const Sentinel2Transparent = {
  'raster-opacity': 1
}

export const CmemsSeaIce = {
  'raster-opacity': 1
}

export const CmemsSnowThickness = {
  'raster-opacity': 1
}

export const Coastline = {
  'raster-opacity': 1
}

export const Sentinel1Wms = {
  'raster-opacity': 1
}

export const Sentinel2PipelineChangeDetection = {
  'raster-opacity': 1
}

export const Modis = {
  'raster-opacity': 1
}

export const IceDrift = {
  'raster-opacity': 1
}

export const IceDriftVelocity = {
  'raster-opacity': 1
}

export const IceDrift2 = {
  'raster-opacity': 1
}

export const WaterTemperature = {
  'raster-opacity': 1
}

export const WaterSediment = {
  'raster-opacity': 1
}

export const WaterRiverSsc = {
  'raster-opacity': 1
}

export const WaterLakeTss = {
  'raster-opacity': 1
}

export const WaterLakeChl = {
  'raster-opacity': 1
}

export const WaterLakeTssVector = {
  'fill-opacity': 1,
  'fill-color': [
    'interpolate',
    ['linear'],
    ['to-number', ['get', 'Name']],
    -2, 'red',
    0, RIVER_CLASS_COLORS[0],
    1500, RIVER_CLASS_COLORS[1],
    3000, RIVER_CLASS_COLORS[2]
  ],
  'fill-outline-color': 'rgba(0, 0, 0, 0)'
}

export const WaterLakeTssHeat = {
  'heatmap-opacity': 1,
  'heatmap-weight': {
    property: 'value',
    type: 'exponential',
    stops: [[0, 0], [50, 1]]
  },
  'heatmap-color': [
    'interpolate',
    ['linear'],
    ['heatmap-density'],
    0,
    'blue',
    0.25,
    'green',
    0.5,
    'yellow',
    0.8,
    'red'
  ]
}

export const InfrastructurePipeline = {
  'raster-opacity': 1
}

export const InfrastructurePipelineVector = {
  'line-opacity': 1,
  'line-width': 3,
  'line-color': [
    'interpolate',
    ['linear'],
    ['get', 'actualresidentialcount'],
    11,
    '#00FF00',
    26,
    '#FFFF00',
    45,
    '#FFA500',
    50,
    '#FF0000'
  ]
}

export const Infrastructure = {
  'circle-opacity': 1,
  'circle-color': [
    'match',
    ['get', 'name'],
    'Commercial',
    colors[0],
    'Garage',
    colors[1],
    'Residential',
    colors[2],
    'Trailer',
    colors[3],
    /* other */ colors[4]
  ],
  'circle-radius': 5
}

const createStops = (colorsList) => {
  const stops = colorsList.map(item => [item.value, item.color])

  return stops
}

const createStopsPipeline = (colorsList) => {
  const stops = colorsList.map(item => [item.difference, item.color])

  return stops
}

export const WellsiteRank = {
  'fill-opacity': 0,
  'fill-color': {
    property: 'ndvi',
    type: 'exponential',
    stops: createStops(NDVI_COLORS)
  }
}

export const PipelineChangeDetection = {
  'fill-opacity': 1,
  'fill-outline-color': 'rgba(0, 0, 0, 0)',
  'fill-color': {
    property: 'difference',
    type: 'exponential',
    stops: createStopsPipeline(PIPELINE_CHANGE_DETECTION_COLORS)
  }
}

export const EnergirChange = ({ property = 'CHANGE' }) => {

  return {
    'fill-opacity': 1,
    'fill-outline-color': 'rgba(0, 0, 0, 0)',
    'fill-color': {
      property: property,
      type: 'exponential',
      stops: createStopsPipeline(ENERGIR_CHANGE_COLORS)
    }
  }
}

export const PipelineChangeDetectionDemo = {
  'fill-opacity': 1,
  'fill-outline-color': 'rgba(0, 0, 0, 0)',
  'fill-color': {
    property: 'difference',
    type: 'exponential',
    stops: createStopsPipeline(PIPELINE_CHANGE_DETECTION_COLORS_DEMO)
  }
}

// export const WellsiteRank = {
//   'fill-opacity': 1,
//   'fill-color': {
//     property: 'ndvi',
//     type: 'exponential',
//     stops: [
//       [170, lime[900]],
//       [350, lime[700]],
//       [530, lime[500]],
//       [770, lightGreen[500]],
//       [900, green[900]]
//     ]
//   }
// }

export const LeakDetection = {
  'fill-opacity': 1,
  'fill-outline-color': 'rgba(0, 0, 0, 0)',
  'fill-color': [
    'interpolate',
    ['linear'],
    ['number', ['get', 'value']],
    70,
    LEAK_DETECTION_COLORS[0],
    75,
    LEAK_DETECTION_COLORS[1],
    80,
    LEAK_DETECTION_COLORS[2],
    85,
    LEAK_DETECTION_COLORS[3],
    90,
    LEAK_DETECTION_COLORS[4],
    95,
    LEAK_DETECTION_COLORS[5]
  ]
}

// export const RiverIceChurchill = {
//   'fill-opacity': 1,
//   'fill-outline-color': 'rgba(0, 0, 0, 0)',
//   'fill-color': [
//     'match',
//     ['get', 'gridcode'],
//     31,
//     RIVER_CLASS_COLORS[0],
//     32,
//     RIVER_CLASS_COLORS[1],
//     33,
//     RIVER_CLASS_COLORS[2],
//     /* other */ 'black'
//   ]
// }

export const CHURCHILL_RIVER_CLASS_COLORS = ['#044A8F', '#FAF703', '#DC440C']

export const RiverIceChurchill = {
  "fill-opacity": 1,
  "fill-outline-color": "rgba(0, 0, 0, 0)",
  "fill-color": [
    "match",
    ["get", "gridcode"],
    31, "#044A8F",
    32, "#6BC0E9",
    33, "#FAF703",
    34, "#DC440C",
    "black"
  ]
}



// WEBPACK FOOTER //
// ./src/layers/paints.js